export enum StatusFilterEnum {
    all,
    active,
    comingSoon,
    completed,
}
